export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7652.ddad7676.jpg";